const items = [
   {
      icon: 'list',
      text: 'Orçamento',
      entity: 'budget',
   },
   {
      icon: 'description',
      text: 'Contrato',
      entity: 'contract',
   },

   {
      icon: 'list_alt',
      text: 'Requisições',
      entity: 'requests',
   },
   {
      icon: 'description',
      text: 'Contratos Inicial',
      entity: 'initialapproval',
   },
   {
      icon: 'assignment',
      text: 'Estoque',
      entity: 'stock',
   },
   {
      icon: 'person',
      text: 'Cliente',
      entity: 'client',
   },
   {
      icon: 'face',
      text: 'Usuário',
      entity: 'user',
   },
   {
      icon: 'business',
      text: 'Empresa',
      entity: 'company',
   },
   {
      icon: 'location_city',
      text: 'Cidade',
      entity: 'city',
   },
   {
      icon: 'build',
      text: 'Serviço',
      entity: 'office',
   },
   {
      icon: 'gavel',
      text: 'Convenção Coletiva',
      entity: 'convention',
   },
   {
      icon: 'all_inbox',
      text: 'Categoria de Produto',
      entity: 'category',
   },
   {
      icon: 'move_to_inbox',
      text: 'Produto',
      entity: 'product',
   },
]
class AccessItems {
   static getItems() {
      return items
   }
}
export default AccessItems



// WEBPACK FOOTER //
// ./src/data/Access/access.js